import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-708eb2ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex justify-content-center align-items-center flex-column" }
const _hoisted_2 = { class: "title my-3 my-lg-5" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "description padd-button" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, "2022年1月1日 0:00～9:00", -1))
const _hoisted_9 = { class: "description" }

import { translate } from '@/languages/i18n'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('zz20_503_title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('zz20_503_content1')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translate)('zz20_503_content2')), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(translate)('zz20_503_content3')), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(translate)('zz20_503_content4')), 1),
      _hoisted_8,
      _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(translate)('zz20_503_content5')), 1)
    ])
  ]))
}
}

})